<template>
	<section class="app-container">
		<div class="container">
			<div class="species-component">
				<h1>Odonata Species</h1>
				<nav id="filter-menu">
					<div class="clearfix">
						<h4 class="pull-left">Filter Results</h4>
						<a class="pull-right" @click="filterOffside.close()"><i class="fa fa-close fa-2x"></i></a>
					</div>
					<sighting-filters v-if="current_user_loaded" :currentUser="current_user" @filterChanged="filterChanged" disableDefaultExcludeDotMap="true" hideExcludeiNat="true"></sighting-filters>
				</nav>
				<div class="offside-overlay"></div>
					<div class="records-filter-summary clearfix">
						<sighting-filters-summary v-model="filters"></sighting-filters-summary>
					</div>
					<div class="pull-right records-buttons">
						<button class="btn" onclick="window.print();"><span class="fa fa-print"></span> Print Checklist</button>
						<button class="btn btn-primary btn-filter"><span class="fa fa-filter"></span> Filter Results</button>
					</div>
					<br class="clear" />
					<div v-bind:class="{ overlayLoading: loading }">
						<div class="loading-overlay" v-show="loading">
							<div class="spinner-wrapper">
								<span class="spinner-text">LOADING</span>
								<span class="spinner"></span>
							</div>
						</div>
						<div class="categorized-species" v-if="taxa">
							<div class="visible-md visible-lg d-print-block-too">
								<div class="row row-header">
									<div class="col-md-6">
										<strong>Species ({{taxa.length}} total)</strong>
									</div>
									<div class="col-md-2">
										<strong>Adult Early Date</strong>
									</div>
									<div class="col-md-2">
										<strong>Adult Late Date</strong>
									</div>
									<div class="col-md-1 text-center d-print-none">
										<strong>Map</strong>
									</div>
									<div class="col-md-1 text-center d-print-none">
										<strong>Records</strong>
									</div>
								</div>
							</div>
							<div class="row row-taxon row-alternating" v-for="(taxon, index) in taxa" :key="taxon.id">
								<div class="col-md-12 col-taxon-divider notranslate" translate="no" v-if="index == 0 || showFamilyDivider(taxon, taxa[index - 1])">
									<em>{{taxon.family.scientific_name}} </em>({{taxon.family.common_name}})
								</div>
								<div class="col-md-6">
									<h5 class="species-title notranslate" translate="no">
										<div class="print-checkbox d-none d-print-inline-block"></div>
										<em>{{taxon.scientific_name}}</em> ({{taxon.common_name}})
									</h5>
								</div>
								<div class="col-md-2">
									{{taxon.earliest_date}}
								</div>
								<div class="col-md-2">
									{{taxon.latest_date}}
								</div>
								<div class="col-md-1 text-center d-print-none">
									<router-link :to="{ path: '/maps/', query: { filterqs: getTaxonQueryString(taxon, true) }}"><i class="fa fa-globe fa-2x"></i></router-link>
								</div>
								<div class="col-md-1 text-center d-print-none">
									<router-link :to="{ path: '/data/records/', query: { filterqs: getTaxonQueryString(taxon, false) }}"><i class="fa fa-th-list fa-2x"></i></router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	name: 'SpeciesComponent',
	metaInfo: {
      title: 'Dragonfly & Odonate Species',
      meta: [
        { name: "description", content: 'Dragonfly & Odonate Species by taxonomy, location, and more.' },
      ],
    },
	mounted(){
		var self = this;
        self.GetAPIUser(function(user){
        	self.current_user_loaded=true;
            self.current_user = user;
        });

		this.filterOffside = offside( '#filter-menu', {
				buttonsSelector: '.btn-filter',
				slidingSide: 'right', 
		});

		$('.offside-overlay').click(function(){self.filterOffside.close()});

	},
	data: function(){
		return {
			taxa: [],
			loading: true,
			filter_string: '',
			current_sighting_id:null,
			filterOffside:null,
			filters:null,
			current_user:null,
			current_user_loaded:false,
		};
	},
	methods:{
		getTaxonQueryString: function(taxon, excludeiNat){
			var ret = this.$route.query.filterqs;
			if (excludeiNat) {
				ret += "|excludeinat"
			}
			ret += "|taxons:" + taxon.id;
			return ret;
		},
		showFamilyDivider: function(taxon, previousTaxon){
			return taxon.family.id != previousTaxon.family.id;
		},
		getData: function(){
			this.loading = true;
			var self = this;
			var qs = "&per_page=1000";
			qs += "&include[]=family.*";
			qs += self.filter_string;

			this.API({
				endpoint: 'sightings/taxa',
				querystring: qs,
				funcThen: function(response){
					self.taxa = response.data.taxa;
				},
				funcAfterThen: function(){
					self.loading = false;
				}
			});
		},
		filterChanged: function(filters, filter_string,by_user_action){
			this.filters = JSON.parse(JSON.stringify(filters));
			this.filter_string = filter_string;
			this.getData();
			if (this.filterOffside) {
				this.filterOffside.close();
			}
		}
	},
	watch:{
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Species.vue